<template>
  <div class="pt-2" style="font-family: PingFangSC-Medium, PingFang SC;height: 100vh;padding: 10px;margin-bottom: 200px;">
    <v-card flat>
      <div style="padding: 10px;">
        <table-search
            :form-inline="formInline"
            :form-item-list="formItemList">
          <div slot="opera">
            <el-button size="small" plain type="primary" @click="onSubmit" icon="el-icon-search">搜&nbsp;索</el-button>
            <el-button size="small" small type="default" @click="reset">重&nbsp;置</el-button>
          </div>
        </table-search>
      </div>
      <div style="padding: 10px;">
        <div>
          <el-button size="small" v-if="_hasButtonPermission('新增')" plain type="primary" icon="el-icon-plus" @click="createRecord">新增</el-button>
        </div>
      </div>
      <div style="margin-top: 15px;min-height: 500px;padding: 10px;">
        <table-merge
            :table-data="tableData"
            :table-field="tableField"
            :table-config="tableConfig"
            :page-info="pageInfo">
          <div slot="handleType" slot-scope="{ item }">
            <span v-if="item.handleType == 1">线上</span>
            <span v-else-if="item.handleType == 2">存款售卡</span>
            <span v-else-if="item.handleType == 3">售预开卡</span>
            <span v-else-if="item.handleType == 4">普通售卡</span>
          </div>
          <div slot="status" slot-scope="{ item }">
            <span v-if="item.status == 1">已保存</span>
            <span v-if="item.status == 2">审核通过</span>
            <span v-if="item.status == 3">审核未通过</span>
            <span v-if="item.status == 4">已激活</span>
            <span v-if="item.status == 5">已作废</span>
          </div>
          <div slot="opera" slot-scope="{ item }">
            <el-button size="small" type="primary" @click="viewItem(item)" plain>查看</el-button>
            <el-button size="small" v-if="(item.status == 3 || item.status == 5) && _hasButtonPermission('修改')" type="warning" @click="editItem(item)" plain>修改</el-button>
            <el-button size="small" type="success" v-if="(item.status == 2 || item.status == 4) && _hasButtonPermission('打印')" @click="print(item)" plain>打印</el-button>
            <el-button size="small" v-if="item.status == 2 || item.status == 4" type="info" @click="printList(item)" plain>打印记录</el-button>
            <el-button size="small" type="info" @click="viewDetailList(item)" plain>赠券记录</el-button>
          </div>
        </table-merge>
      </div>

    </v-card>
  </div>
</template>

<script>
import TableMerge from "../../../../components/elTable/tableMerge";
import TableSearch from "../../../../components/elTable/tableSearch";
import GrouponApi from "../../../../api/sm/market/groupon/grouponApi"
import { default as commonIn } from '@/util/common'
import StoreApi from "../../../../api/pd/common/StoreApi";
import JsBarCode from "jsbarcode";
export default {
  name: "grouponList",
  components: {TableSearch, TableMerge},
  props: {
    page: {
      type: Object,
      default: null
    },
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      printInfoItem: {},
      isPrint: false,
      printItem: [],
      dialogPrintVisible: false,
      tableConfig: {
        isCheckBox: 0,
        isOpera: 1,
        fixed: 'right',
        operaWidth: 350
      },
      tableData: [],
      tableField: [
        { columnCode: 'id', columnName: '单据编号', isSlot: 0, width: 200 },
        { columnCode: 'shopName', columnName: '门店', isSlot: 0, width: 120 },
        { columnCode: 'handleNo', columnName: '卖券单号', isSlot: 0, width: 100 },
        { columnCode: 'handleType', columnName: '卖券单类型', isSlot: 1, width: 120 },
        { columnCode: 'groupAmount', columnName: '团购金额', isSlot: 0, width: 80 },
        { columnCode: 'groupNum', columnName: '团购数量', isSlot: 0, width: 80 },
        { columnCode: 'sendCouponRatio', columnName: '返券比例', isSlot: 0, width: 80 },
        { columnCode: 'sendCouponAmount', columnName: '返券总额', isSlot: 0, width: 80 },
        { columnCode: 'sendCouponNum', columnName: '返券张数', isSlot: 0, width: 80 },
        { columnCode: 'customerName', columnName: '客户名称', isSlot: 0, width: 100 },
        { columnCode: 'agentName', columnName: '代办员名称', isSlot: 0, width: 120 },
        { columnCode: 'agentMobile', columnName: '代办员手机号', isSlot: 0, width: 120 },
        { columnCode: 'customerSpecialist', columnName: '客户专员', isSlot: 0, width: 100 },
        { columnCode: 'createName', columnName: '制单人', isSlot: 0, width: 100 },
        { columnCode: 'createTime', columnName: '制单时间', isSlot: 0, width: 120 },
        { columnCode: 'status', columnName: '状态', isSlot: 1, width: 80 },
      ],
      pageInfo: {
        currentPage: 1,
        pageSize: 15,
        total: 50
      },
      formInline: {
        handleNo: '',
        shopIdList: null,
        createTime: null,
        createName: '',
        handleType: '',
        agentMobile: '',
        customerSpecialist: '',
        status: ''
      },
      formItemList: [
        {
          label: '门店', code:'shopIdList', type: 'select', placeholder: '请选择门店', list: [], multiple: true
        },
        {
          label: '卖券单号', code: 'handleNo', type: 'text', placeholder: '请输入'
        },
        {
          label: '卖券单类型', code:'handleType', type: 'select', placeholder: '请选择卖券单类型', list: [
            {label: '线上', value: 1}, {label: '存款售卡', value: 2}, {label: '售预开卡', value: 3}, {label: '普通售卡', value: 4}
          ], multiple: false
        },
        {
          label: '客户名称', code: 'customerName', type: 'text', placeholder: '请输入'
        },
        {
          label: '代办员手机号', code: 'agentMobile', type: 'text', placeholder: '请输入'
        },
        {
          label: '客户专员', code: 'customerSpecialist', type: 'text', placeholder: '请输入'
        },
        {
          label: '制单人', code: 'creatName', type: 'text', placeholder: '请输入'
        },
        {
          label: '制单时间', code: 'createTime', type: 'date', dateType: 'daterange', dateFormat: 'yyyy-MM-dd HH:ii:ss'
        },
        {
          label: '状态', code:'status', type: 'select', placeholder: '请选择状态', list: [
            {label: '已保存', value: 1}, {label: '审核通过', value: 2}, {label: '审核未通过', value: 3}, {label: '已作废', value: 4}, {label: '已激活', value: 5}
          ], multiple: false
        }
      ]
    }
  },
  watch: {
    pageInfo: {
      handler(newVal) {
        console.log(newVal)
        if (newVal.currentPage && newVal.pageSize) {
          this.getList()
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {

  },
  mounted() {
    this.getStore()
    this.getList()
  },
  methods: {
    // 获取门店列表
    getStore() {
      let that = this
      StoreApi.queryStoreList().then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.optionStore = res.data.shopPriviledges
          let arrIn = []
          that.optionStore.map(item => {
            let storeInfo = {
              label: item.shopName,
              value: item.shopId
            }
            arrIn.push(storeInfo)
          })
          that.formItemList[0].list = arrIn
        } else {
          that.$message.error(res.msg)
        }
      }).catch(error => {
        console.log(error)
        that.$message.warning('系统错误！请稍后尝试')
      })
    },
    // 查找
    onSubmit() {
      this.getList()
    },
    reset() {
      this.formInline.createName = ''
      this.formInline.agentMobile = ''
      this.formInline.handleNo = ''
      this.formInline.status = ''
      this.formInline.shopIdList = null
      this.formInline.createTime = null
      this.formInline.handleType = ''
      this.formInline.customerSpecialist = ''
      this.pageInfo.currentPage = 1

      this.getList()
    },
    // 新增记录
    createRecord() {
      this.$emit("addCallbackCreate", {formStatus:'add'})
    },
    // 查看详情
    viewItem(item) {
      this.$emit("addCallbackDetail", {formStatus:'detail', item: item})
    },
    editItem(item) {
      this.$emit("addCallbackCreate", {formStatus:'detail', item: item})
    },
    // 查看赠券记录
    viewDetailList(item) {
      this.$emit("addCallbackDetailList", {formStatus:'detailList', item: item})
    },
    print(item) {
      this.$emit("addCallbackPrint", {formStatus:'print', item: item})
    },
    printList(item) {
      this.$emit("addCallbackPrintList", {formStatus:'printList', item: item})
    },
    getList() {
      let that = this
      let params = this.formInline
      params.pageNo =  this.pageInfo.currentPage,
      params.pageSize = this.pageInfo.pageSize

      GrouponApi.getList(params).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.tableData = res.data.rows
          that.tableData.map(item => {
            item.createTime = commonIn.timeFormatSeconds(item.createTime)
          })
          that.pageInfo.total = res.data.total
        }
      })
    },
    _hasButtonPermission(name) {
      console.log(this.buttonPriviledgeList)
      let buttonPriviledgeList = this.buttonPriviledgeList
      console.log(buttonPriviledgeList)
      let hasButton = false
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == 'Y') {
            return true
          } else {
            return false
          }
        }
      }
      return false
    }
  }
}
</script>

<style scoped>

</style>